import React from "react";
import { BUSINESS } from "@/lib/business";

// Inline SVG WhatsApp logo
function WhatsAppIcon({ className = "w-7 h-7" }) {
  return (
    <svg viewBox="0 0 32 32" className={className} fill="currentColor" aria-hidden="true">
      <path d="M19.11 17.21c-.3-.15-1.79-.88-2.06-.98-.28-.1-.48-.15-.68.15-.2.3-.78.98-.96 1.18-.17.2-.35.22-.65.07-.3-.15-1.27-.47-2.42-1.5-.9-.8-1.5-1.79-1.67-2.09-.17-.3-.02-.46.13-.61.13-.13.3-.34.45-.51.15-.17.2-.3.3-.5.1-.2.05-.37-.02-.52-.08-.15-.68-1.64-.93-2.25-.24-.58-.49-.5-.68-.51l-.58-.01c-.2 0-.52.07-.79.37s-1.04 1.02-1.04 2.49 1.07 2.88 1.22 3.08c.15.2 2.1 3.2 5.09 4.49.71.31 1.27.5 1.7.64.71.23 1.36.2 1.87.12.57-.09 1.79-.73 2.04-1.43.25-.7.25-1.3.17-1.43-.07-.13-.27-.2-.57-.35zM16.02 5.33c-5.91 0-10.71 4.8-10.71 10.71 0 1.88.49 3.71 1.42 5.33L5 27.33l5.97-1.57a10.66 10.66 0 0 0 5.05 1.28h.01c5.9 0 10.7-4.8 10.71-10.71 0-2.86-1.11-5.55-3.13-7.57a10.63 10.63 0 0 0-7.59-3.13zm0 19.51h-.01a8.87 8.87 0 0 1-4.53-1.24l-.32-.19-3.55.93.95-3.46-.21-.36a8.87 8.87 0 0 1-1.36-4.73c0-4.91 4-8.9 8.93-8.9 2.39 0 4.63.93 6.32 2.62a8.86 8.86 0 0 1 2.62 6.31c-.01 4.92-4.01 8.92-8.93 8.92z" />
    </svg>
  );
}

export default function WhatsAppButton() {
  return (
    <a
      data-testid="whatsapp-floating-button"
      href={BUSINESS.whatsappUrl}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="WhatsApp"
      className="fixed bottom-6 left-6 z-50 w-14 h-14 md:w-16 md:h-16 rounded-full bg-[#25D366] hover:bg-[#1ebe57] text-white flex items-center justify-center glow-green hover:scale-110 active:scale-95 transition-all duration-300"
    >
      <WhatsAppIcon className="w-7 h-7 md:w-8 md:h-8" />
      <span className="absolute inset-0 rounded-full bg-[#25D366] opacity-40 animate-ping" />
    </a>
  );
}
